import omitBy from 'lodash/omitBy';
import isNull from 'lodash/isNull';
import PropTypes from 'prop-types';

export const apiTransformer = log => {
  const { id = '', attributes = {} } = log;
  const logData = omitBy(attributes, isNull);

  return {
    id,
    action: logData.action,
    clientIpAddress: logData.client_ip_address,
    component: logData.component,
    customer: logData.cust_customer,
    details: logData.details,
    employee: logData.employee,
    eventTimestamp: logData.event_timestamp,
    eventType: logData.event_type,
    location: logData.location,
    message: logData.message,
    metadata: logData.metadata,
    object: logData.object,
    objectIDs: logData.object_ids,
    product: logData.product,
    register: logData.register,
    source: logData.source,
    sourceTimestamp: logData.source_timestamp,
    status: logData.status,
    userAgent: logData.user_agent,
    userID: logData.user_id,
    visibility: logData.visibility,
  };
};

export const logPropTypes = PropTypes.shape({
  id: PropTypes.string,
  action: PropTypes.string,
  component: PropTypes.string,
  details: PropTypes.string,
  device: PropTypes.shape({
    id: PropTypes.number,
    info: PropTypes.string,
    name: PropTypes.string,
  }),
  employee: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }),
  eventTimestamp: PropTypes.string,
  eventType: PropTypes.string,
  location: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }),
  message: PropTypes.string,
  metadata: PropTypes.string,
  object: PropTypes.string,
  objectID: PropTypes.arrayOf(PropTypes.number),
  product: PropTypes.string,
  register: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }),
  source: PropTypes.string,
  sourceTimestamp: PropTypes.string,
  status: PropTypes.oneOf([0, 1]),
  userID: PropTypes.number,
  visibility: PropTypes.number,
});

export const STATUS_CODES = {
  FALSE: 0,
  TRUE: 1,
};
